<template>
  <div class="text-data" :id="operationId">
    <operation-value
      :key="operationId"
      :element="element"
      :operations="operations"
      :container="'#' + operationId + '.text-data'"
      :getLang="getLang"
    />
    <transition name="fade" mode="out-in">
      <div v-if="showTextValue" class="section-value">
        <span class="label"><i class="sherpa-icon icon-editar"></i> {{ getLang('textSelection') }}</span>
        <transition name="fade-slide-left" mode="out-in">
          <template v-if="showListField">
            <input v-model="element.operation.textListValue" class="input-value" @input="validateTextList()" />
          </template>
          <template v-else>
            <input v-model="element.operation.textValue" class="input-value" />
          </template>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import operationValue from './operationValue'

const textListRegex = /^([^|]*)(\s*\|\s*[^|]*)*$/

export default {
  name: 'text-data',
  components: {
    operationValue
  },
  props: {
    element: Object,
    getLang: Function,
    selected: Boolean,
    sendConditionResume: Function
  },
  data () {
    return {
      previousTextListValue: this.element.operation.textListValue
    }
  },
  computed: {
    showTextValue () {
      return !['informed', 'not-informed'].includes(this.element.operation.operationValue)
    },
    showListField () {
      return ['on-list', 'off-list'].includes(this.element.operation.operationValue)
    },
    operations () {
      return [
        {key: 'equal', name: this.getLang('opTextEqualName'), description: this.getLang('opTextEqualDesc')},
        {key: 'contains', name: this.getLang('opTextContainsName'), description: this.getLang('opTextContainsDesc')},
        {key: 'starts-with', name: this.getLang('opTextStartsWithName'), description: this.getLang('opTextStartsWithDesc')},
        {key: 'ends-with', name: this.getLang('opTextEndsWithName'), description: this.getLang('opTextEndsWithDesc')},
        {key: 'not-equal', name: this.getLang('opTextNotEqualName'), description: this.getLang('opTextNotEqualDesc')},
        {key: 'not-contains', name: this.getLang('opTextNotContainsName'), description: this.getLang('opTextNotContainsDesc')},
        {key: 'on-list', name: this.getLang('opTextOnListName'), description: this.getLang('opTextOnListDesc')},
        {key: 'off-list', name: this.getLang('opTextOffListName'), description: this.getLang('opTextOffListDesc')},
        {key: 'informed', name: this.getLang('opTextInformedName'), description: this.getLang('opTextInformedDesc')},
        {key: 'not-informed', name: this.getLang('opTextNotInformedSomeName'), description: this.getLang('opTextNotInformedSomeDesc')}
      ]
    },
    operationId () {
      return 'operation_' + this.element.id
    }
  },
  methods: {
    validateTextList () {
      const val = this.element.operation.textListValue
      if (val === '' || textListRegex.test(val)) {
        this.previousTextListValue = val
      } else {
        this.element.operation.textListValue = this.previousTextListValue
      }
    },
    getValuesStr () {
      if (this.element.operation && this.showTextValue) {
        if (this.showListField) {
          return ': \'' + this.element.operation.textListValue + '\''
        } else {
          return ': \'' + this.element.operation.textValue + '\''
        }
      } else {
        return ''
      }
    }
  },
  beforeMount () {
    this.$emit('textLoaded', true)
  },
  watch: {
    showTextValue (value) {
      this.$emit('showTextValue', value)
    },
    element: {
      handler () {
        this.sendConditionResume(this)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.text-data {
}
</style>
